import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

export default function BpProtectedRoute() {
  const { bpLoginInfo } = useAuthContext();
  //@check expires date also
  return bpLoginInfo?.token?.access_token ? <Outlet /> : <Navigate to="/" replace />;
}